import { GAME_ID, REDUX_ACTIONS } from '../../../data/constants';

export const initialState = {
  isSlideBeingBlocked: false,
  isAlignedToLeft: false,
};

const scrollViewReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case REDUX_ACTIONS.SET_SCROLLVIEW_LEFT_ALIGNED:
      return {
        ...state,
        isAlignedToLeft: payload,
      };

    case REDUX_ACTIONS.SET_BLOCKING_TEXT_ITEM_SLIDE:
      return {
        ...state,
        isSlideBeingBlocked: payload,
      };

    case REDUX_ACTIONS.CHANGE_SCREEN:
      return {
        ...initialState,
      };

    default:
      return state;
  }
};

export default scrollViewReducer;
